import React, { useState, useEffect } from "react";
import { Button, Select } from "antd";
import { ClearOutlined } from "@ant-design/icons";
import { releaseNotesData } from "../../../../Utils/releaseNotesData";
import { ReleaseNoteType } from "../../../../Interface";

const releaseNoteStatusOptions = [
  { label: "Current", value: "current" },
  { label: "Upcoming", value: "upcoming" },
  { label: "Deprecated", value: "deprecated" },
];

const releaseNoteVersionOptions = releaseNotesData.map((releaseNote) => ({
  label: releaseNote.version,
  value: releaseNote.version,
}));

interface ReleaseNoteFilterMenuProps {
  setFilteredReleaseNotes: React.Dispatch<
    React.SetStateAction<ReleaseNoteType[]>
  >;
}

const ReleaseNoteFilterMenu: React.FC<ReleaseNoteFilterMenuProps> = ({
  setFilteredReleaseNotes,
}) => {
  const [statusFilter, setStatusFilter] = useState<string | undefined>(
    undefined
  );
  const [versionFilter, setVersionFilter] = useState<string | undefined>(
    undefined
  );

  const applyFilters = (
    status: string | undefined,
    version: string | undefined
  ) => {
    const filtered = releaseNotesData.filter((releaseNote) => {
      const matchesStatus =
        status === undefined || releaseNote.status === status;
      const matchesVersion =
        version === undefined || releaseNote.version === version;
      return matchesStatus && matchesVersion;
    });
    setFilteredReleaseNotes(filtered);
  };

  useEffect(() => {
    applyFilters(statusFilter, versionFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFilter, versionFilter]);

  const handleStatusFilter = (value: string | undefined) => {
    setStatusFilter(value);
  };

  const handleVersionFilter = (value: string | undefined) => {
    setVersionFilter(value);
  };

  const handleClearAll = () => {
    setStatusFilter(undefined);
    setVersionFilter(undefined);
  };
  return (
    <div className="release-note-filter-menu">
      <Select
        placeholder="Filter by status"
        options={releaseNoteStatusOptions}
        allowClear
        onChange={handleStatusFilter}
        value={statusFilter}
      />
      <Select
        placeholder="Filter by version"
        options={releaseNoteVersionOptions}
        allowClear
        onChange={handleVersionFilter}
        value={versionFilter}
      />
      <Button
        type="default"
        size="middle"
        icon={<ClearOutlined />}
        onClick={handleClearAll}
      >
        Clear All
      </Button>
    </div>
  );
};

export default ReleaseNoteFilterMenu;
